'use strict';

require('angular');
require('angular-aria');
require('angular-animate');
require('angular-ui-router');
require('bootstrap');
require('angular-ui-bootstrap');
require('angular-sanitize');
require("./assets/js/alcomponents")
require("./assets/js/alservices")
require("./assets/js/select2.js");
require("./assets/js/select2-comp.js");
require('ms-signalr-client');


//Excel Data Manipulation
// window.XLSX = require('xlsx');
// window.lodash = require('lodash');
// window.XLSXReader = require("./assets/js/xlsx-reader.js");

//window.humanizeDuration = require('humanize-duration');
//window.moment = require('moment');
document.write(require("./base.html"));

var app  = require('./app/app');
angular.element(document).ready(function () {  
  angular.bootstrap(document, [app.app.name], {
    // strictDi: true
  });
});



//////////////////
// WEBPACK FOOTER
// ./index.js
// module id = 100
// module chunks = 0